export const txtConfirmationTitle = {
  id: "Konfirmasi Pengiriman",
  en: "Gift Confirmation",
};

export const txtInputSenderPlaceholder = {
  id: "Nama pengirim",
  en: "Sender name",
};

export const txtInputAccount = {
  id: "Pilih rekening tujuan",
  en: "Select destination account",
};

export const txtInputNominal = {
  id: "Jumlah pengiriman",
  en: "Amount",
};

export const txtOkConfirmation = {
  id: "Konfirmasi",
  en: "Confirm",
};

export const txtOkConfirming = {
  id: "Sedang mengonfirmasi...",
  en: "Confirming...",
};

export const txtCancelConfirmation = {
  id: "Batal",
  en: "Cancel",
};
